import { Component, ViewChild, ElementRef, AfterViewInit , OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { ApiService } from '../../api/api.service';
import { AuthguardService } from '../../api/authguard.service';
import { first } from 'rxjs/operators';
import { result } from 'lodash';
import { Router } from '@angular/router';
import { FormService } from '../../api/form.service';

@Component({
  selector: 'app-test-reg',
  templateUrl: './test-reg.component.html',
  styleUrls: ['./test-reg.component.css']
})
export class TestRegComponent implements OnInit {

  @ViewChild('UploadFileInput', { static: false }) uploadFileInput!: ElementRef;
  @ViewChild('uploadFileResInput', { static: true, read: ElementRef }) uploadFileResInput!: ElementRef;
  @ViewChild('uploadFileCerInput', { static: true, read: ElementRef }) uploadFileCerInput!: ElementRef;

  fileUploadForm: any;
  fileInputLabel: any;
  valName: any ;
  valEmail: any;
  valRefId: any;
  valMobile: any;

  public endYear:any = new Date().getFullYear();
  arr_year:any = [];

  constructor(
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private api: ApiService,
    private AuthguardService: AuthguardService,
    private router: Router,
    private formaction: FormService
  ) {

   }

   canActivate(): boolean {
    if (!this.AuthguardService.gettoken()) {
        this.router.navigateByUrl("/testLogin");
    }
    return this.AuthguardService.gettoken();
}

  ngOnInit(): void {

    this.yearShort();

    this.api.liststate().subscribe((data:any)=>{
      this.state = data;
      //console.log(data);
    });

    //this.valtext1 = 'AAA';
    if(window.localStorage.getItem('logged_in') == 'TRUE'){
      this.formaction.get_family_head_result().subscribe((result:any)=>{

        this.valRefId = result[0]['refno'];
        this.valName = result[0]['name'];
        this.valEmail = result[0]['email'];
        this.valMobile = result[0]['mobile'];

        //this.valtext1 = JSON.stringify(result.refno);

      });
    }



    this.fileUploadForm = this.formBuilder.group({
      uploadName: new FormControl(),
      uploadEmail: new FormControl(),
      uploadRefId: new FormControl(),
      uploadMobile: new FormControl(),
      // uploadedText: new FormControl(),
      // uploadedText1: new FormControl(),
      uploadedImage: new FormControl(),
      uploadedPdf: new FormControl(),
      uploadedCer: new FormControl(),
      name: ['', Validators.required],
      gender: ['', Validators.required],
      dob: ['', Validators.required],
      fathername: ['', Validators.required],
      mobilenumber: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      maritalstatus: ['', Validators.required],
      category: ['', Validators.required],
      divyang: ['', Validators.required],
      nationality: ['', Validators.required],
      doorno: ['', Validators.required],
      streetname: ['', Validators.required],
      area: ['', Validators.required],
      vtc: ['', Validators.required],
      pincode: ['', Validators.required],
      state: ['', Validators.required],
      district: ['', Validators.required],
      c_doorno: ['', Validators.required],
      c_streetname: ['', Validators.required],
      c_area: ['', Validators.required],
      c_vtc: ['', Validators.required],
      c_pincode: ['', Validators.required],
      c_state: ['', Validators.required],
      c_district: ['', Validators.required],
      pastexperience: [''],
      applypost: ['', Validators.required],
      image: [''],
      presently: ['', Validators.required],
      present: ['', Validators.required],
      relevent: ['', Validators.required],
      certificate: [''],
      resume: [''],
      acceptTerms: ['', Validators.required],
      qualification: this.formBuilder.array([]) ,
      professional:  this.formBuilder.array([]) ,
      workexp:  this.formBuilder.array([]) ,
    });
  }


  onFileSelect(event:any) {
    const file = event.target.files[0];

    var reader = new FileReader();
    console.log(reader);
    // this.fileInputLabel = file.name;
    console.log(file.size);

    if(50000 < file.size){
      alert("Upload Only 50kb");
      this.uploadFileInput.nativeElement.value = "";
    }

    this.fileArraData = event.target.files[0];

    console.log(this.fileArraData);

   if (event.target.files && event.target.files[0]) {
     const file = event.target.files[0];

     const reader = new FileReader();
     reader.onload = e => this.fileArraData = reader.result;
     console.log(this.fileArraData);

     reader.readAsDataURL(file);
 }

    // this.fileArray = file;
    this.fileUploadForm.get('uploadedImage').setValue(file);
  }

  public fileArraData:any;

  handleFileInput(data:any){
    // console.log(data.target.files)
    this.fileArraData = data.target.files[0];

     console.log(this.fileArraData);

    if (data.target.files && data.target.files[0]) {
      const file = data.target.files[0];

      const reader = new FileReader();
      reader.onload = e => this.fileArraData = reader.result;
      console.log(this.fileArraData);

      reader.readAsDataURL(file);
  }
  }

  onFileSelectRes(event:any) {
    const file = event.target.files[0];
    // this.fileInputLabel = file.name;
    console.log(file);
    if(50000 < file.size){
      alert("Upload Only 50kb");
      this.uploadFileResInput.nativeElement.value = "";
    }
    // this.fileArray = file;
    this.fileUploadForm.get('uploadedPdf').setValue(file);
  }

  onFileSelectCer(event:any){
    const file = event.target.files[0];
    if(50000 < file.size){
      alert("Upload Only 50kb");
      this.uploadFileResInput.nativeElement.value = "";
    }
    // this.fileArray = file;
    this.fileUploadForm.get('uploadedCer').setValue(file);
  }

public rollno:any;
public text1:any;
public text2:any;
public uplImg:any;
public uplRes:any;

  onFormSubmit() {

    this.submitted = true;

    if (this.fileUploadForm.invalid) {
      return;
    }

    console.log(this.fileUploadForm.get('uploadedImage').value);
    if (!this.fileUploadForm.get('uploadedImage').value && !this.fileUploadForm.get('uploadedCer').value && !this.fileUploadForm.get('uploadedPdf').value) {
      alert('Please fill valid details!');
      return;
    }

      // this.api.uploadFile(this.fileArray,this.fileUploadForm.value.uploadedText,this.fileUploadForm.value.uploadedText1).pipe(first()).subscribe((res:any)=>{
      //   console.log(res)
      // })




    const formData = new FormData();
    formData.append('uploadedImage', this.fileUploadForm.get('uploadedImage').value);
    formData.append('uploadedPdf', this.fileUploadForm.get('uploadedPdf').value);
    formData.append('uploadedCer', this.fileUploadForm.get('uploadedCer').value);
    formData.append('fileUploadForm', JSON.stringify(this.fileUploadForm.value));

    var myargs = formData;
    var myargsText = this.fileUploadForm.value;
    console.log(myargs)

    this.api.upt_reg_form(myargs).subscribe((result:any)=>{
      console.log(result[0]['refno']);

      this.rollno = result[0]['refno'];
      this.text1 = result[0]['text1'];
      this.text2 = result[0]['text2'];
      this.uplImg = result[0]['img'];
      this.uplRes = result[0]['pdf'];


      if (result.statusCode === 200) {
        // Reset the file input
        this.uploadFileInput.nativeElement.value = "";
        this.fileInputLabel = undefined;
      }
    }, er =>{
      console.log(er);
        alert(er.error.error);
    });

    // this.http.post<any>('http://localhost:5001/uploadfile', formData).subscribe(response => {
    //     console.log(response);
    //     if (response.statusCode === 200) {
    //       // Reset the file input
    //       this.uploadFileInput.nativeElement.value = "";
    //       this.fileInputLabel = undefined;
    //     }
    //   }, er => {
    //     console.log(er);
    //     alert(er.error.error);
    //   });
  }


logout(){
  localStorage.clear();
  this.router.navigateByUrl('/testLogin');
  //localStorage.removeItem("sessionStorage");
}

omit_text(event:any)
{
  var k;
   k = event.charCode;
   return((k > 64 && k < 91) || (k > 96 && k < 123) || k==32);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
omit_text_number(event:any)
{
  var k;
   k = event.charCode;
   return((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k==32);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
omit_email(event:any)
{
  var k;
   k = event.charCode;
   return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 46 || k==64 || k==95 || k==32);
}
omit_number(event:any)
{
  var k;
   k = event.charCode;
   return((k >= 48 && k <= 57) || k==32);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
omit_spl(event:any)
{
  var k;
   k = event.charCode;
   return((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k == 47 || k==32);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
omit_addres(event:any)
{
  var k;
   k = event.charCode;
   return((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k==32);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
omit_decimal(event:any)
{
  var k;
   k = event.charCode;
   return((k >= 48 && k <= 57) || k==32 || k == 46);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}

public dup_doorno:any;
public dup_street:any;
public dup_area:any;
public dup_vtc:any;
public dup_pincode:any;
public dup_state:any;
public dup_district:any;
public bool_crntAddress:boolean = false;

submitted = false;
public date = new Date().getDate();
public month = new Date().getMonth() + 1;
public year = new Date().getFullYear();
public currentDate = this.date + '-' + this.month + '-' + this.year;

get f() { return this.fileUploadForm.controls; }
datePickerConfig = {
  format: 'DD-MM-YYYY',
  max: this.currentDate,
};



onChangeDist(event:any){
  this.bool_crntAddress = true;
}
onChangeAddress(event:any){
  if(event.target.value == 'yes'){

    this.dup_doorno = this.fileUploadForm.value.doorno;
    this.dup_street = this.fileUploadForm.value.streetname;
    this.dup_area = this.fileUploadForm.value.area;
    this.dup_vtc = this.fileUploadForm.value.vtc;
    this.dup_pincode = this.fileUploadForm.value.pincode;
    this.dup_state = this.fileUploadForm.value.state;
    this.dup_district = this.fileUploadForm.value.district;


    return;
  }
  else{
    this.dup_doorno = "";
    this.dup_street = "";
    this.dup_area = "";
    this.dup_vtc = "";
    this.dup_pincode = "";
    this.dup_state = "";
    this.dup_district = "";
    return;
  }

}

public state:any;
public district:any;

onChangeState(data:any){
  //console.log(data.target.value);
  var myargs = {
    stateName: data.target.value
  }
  this.api.enterState(myargs).subscribe((result:any)=>{
    //console.log(JSON.stringify(result));
    this.district = result;
  });
}

//add tabele start

newQuantity(): FormGroup {
  return this.formBuilder.group({
    exampassed: [''],
    yearpass: '',
    university: '',
    substudied: '',
    marks: '',

  })
}


qualification() : FormArray {
  return this.fileUploadForm.get("qualification") as FormArray
}

addQualification() {
  this.qualification().push(this.newQuantity());
}

removeQualification(i:number) {
  this.qualification().removeAt(i);
}



get skills() : FormArray {
  return this.fileUploadForm.get("skills") as FormArray
}

newSkill(): FormGroup {
  return this.formBuilder.group({
    examination_name: '',
    year_of_passing: '',
    name_of_university: '',
    sub_studied: '',
    division_of_marks: '',
  })
}

addSkills() {
this.skills.push(this.newSkill());
}

removeSkill(i:number) {
this.skills.removeAt(i);
}

// prof...

newprofessional(): FormGroup {
return this.formBuilder.group({
  exampassed: '',
  yearpass: '',
  course: '',
  university: '',
  substudied: '',
  marks: '',

})
}


professional() : FormArray {
return this.fileUploadForm.get("professional") as FormArray
}

addprofessional() {
this.professional().push(this.newprofessional());
}

removeprofessional(i:number) {
this.professional().removeAt(i);
}



get professionalskills() : FormArray {
return this.fileUploadForm.get("professional") as FormArray
}

professionalnewSkill(): FormGroup {
return this.formBuilder.group({
  examination_name: '',
  year_of_passing: '',
  details_of_course: '',
  name_of_university: '',
  sub_studied: '',
  division_of_marks: '',
})
}

professionaladdSkills() {
this.skills.push(this.newprofessional());
}

professionalremoveSkill(i:number) {
this.skills.removeAt(i);
}

//Work Exp

newworkexp(): FormGroup {
return this.formBuilder.group({
  addressofemp: '',
  from: '',
  to: '',
  scaleofpay: '',
  service: '',
  naturework: '',

})
}


workexp() : FormArray {
return this.fileUploadForm.get("workexp") as FormArray
}

addworkexp() {
this.workexp().push(this.newworkexp());
}

removeworkexp(i:number) {
this.workexp().removeAt(i);
}



get workexpskills() : FormArray {
return this.fileUploadForm.get("workexp") as FormArray
}

workexpnewSkill(): FormGroup {
return this.formBuilder.group({
  examination_name: '',
  year_of_passing: '',
  details_of_course: '',
  name_of_university: '',
  sub_studied: '',
  division_of_marks: '',
})
}

workexpaddSkills() {
this.skills.push(this.newworkexp());
}

workexpremoveSkill(i:number) {
this.skills.removeAt(i);
}

public  startYear = 1950;
// public  endYear = new Date().getFullYear();
year_short(event:any){
  var val = event.target.value;
  if( !(this.startYear <= val && this.endYear >= val)){
    alert("not Match")
    var reset = this.fileUploadForm.get('professional') as FormArray;
    console.log(reset);

  }
}

yearShort(){
  for ( var i = 1950; i <= this.endYear; i++) {
     this.arr_year.push(i)
  }
  this.arr_year.reverse()
  return;
}



//add table end
}
